<script lang="ts">
  import DiscoveryPanel from "@shared/svelte/DiscoveryPanel/DiscoveryPanel.svelte";
  import PageWrapper from "@retailer/svelte/Shared/PageWrapper.svelte";
  import { default as CraftNavigation } from "@modern/components/retailer/Navigation/ProductLinesNavigation.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { SponsoredContentPageEntity } from "@shared/services/event_tracking/entities";

  import type { SponsoredContentPageWithCustomContentDetails } from "@shared/types/SponsoredContentPage";

  export let sponsoredContentPage: SponsoredContentPageWithCustomContentDetails;
  export let Cart: any = null;

  const { trackMrcEvents } = EventTracking;
  const targetObjectType: string = "sponsored_content_page";
  const sponsoredPageTracking: SponsoredContentPageEntity = new SponsoredContentPageEntity(
    sponsoredContentPage,
  );
  const pageName: string = "custom_content";

  let configuration: any = [];
  const options = {
    method: "GET",
    url: "/api/retailer/discovery_panel/discovery_config",
    data: { page_name: pageName, page_value: sponsoredContentPage.custom_content_id },
  };
  HttpPromise(options)
    .then(res => (configuration = res))
    .catch(() => (configuration = []));
</script>

<TrackingContext entities={sponsoredPageTracking} let:trackingContext>
  <PageWrapper let:mobileMode>
    <CraftNavigation />

    <div class="fizz-styles">
      <div class="fizz-layout-primary">
        <div
          data-testid="sponsored-content-page"
          use:trackMrcEvents={[trackingContext.entities, { targetObjectType }]}
        >
          <main class="fizz-container" data-grid-area="main">
            <DiscoveryPanel bind:configuration {mobileMode} {Cart} {pageName} />
          </main>
        </div>
      </div>
    </div>
  </PageWrapper>
</TrackingContext>
